/** YouTube / Vimeo page link → embeddable player address, else null. */
export function embedUrl(url: string | null | undefined): string | null {
  if (!url) return null
  try {
    const u = new URL(url)
    const host = u.hostname.replace(/^www\.|^m\./, '')
    let id: string | null = null
    if (host === 'youtu.be') id = u.pathname.slice(1)
    else if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
      id = u.searchParams.get('v') ?? /^\/(embed|shorts|live)\/([\w-]+)/.exec(u.pathname)?.[2] ?? null
    }
    if (id && /^[\w-]{6,20}$/.test(id)) return `https://www.youtube-nocookie.com/embed/${id}`
    const vimeo = host === 'vimeo.com' ? /^\/(\d+)/.exec(u.pathname)?.[1] : undefined
    if (vimeo) return `https://player.vimeo.com/video/${vimeo}`
  } catch {
    return null
  }
  return null
}
